import { Typography } from '@arionbanki/arionui';
import { Links } from 'components';
import { FLOW_TYPE } from 'consts/flows';
import screenImg from 'img/screen.svg';
import type { FinishPageProps } from './useFinish';

export function FinishAV({ flowType, keys, links, t }: FinishPageProps) {
	return FLOW_TYPE.AV === flowType ? (
		<>
			<div className="col-12 col-md-7">
				<Typography TagName="h2">{t(keys.leftTitle, 'finish')}</Typography>
				<Typography className="my-5" TagName="p">
					{t(keys.leftText, 'finish')}
				</Typography>
				<Links links={links[0]} />
			</div>
			<div className="col-12 col-md-5">
				<img alt="" className="w-100" src={screenImg} />
			</div>
		</>
	) : null;
}
